
import { of as observableOf,  Observable } from 'rxjs';
import { catchError, map, share, switchMap, withLatestFrom} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { LiveStreamAction } from './live-stream.action';
import { StocksApiService } from '@toro/common/shared/services/stocks/stocks-api.service';

@Injectable()
export class LiveStreamEffects {

    /**
     * Busca o id da live do youtube
     */
    @Effect()
    public getYoutubeLiveId$: Observable<LiveStreamAction> = this.actions$
        .pipe(
            ofType(LiveStreamAction.getLive),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([action, auth]) => {
                const liveUri = `youtube-api/get-youtube-videoid?channel=${action.payload}`;
                return this.stocksApiService.get(liveUri)
                    .pipe(
                        map((result: any) => {
                            if (result.data) {
                                return { type: LiveStreamAction.getLiveSuccess, payload: result.data };
                            }
                            return { type: LiveStreamAction.getLiveError, payload: result };
                        }),
                        catchError((error) => {
                            return observableOf({ type: LiveStreamAction.getLiveError, payload: error });
                        }),
                    );
            }),
            share(),
        );

    constructor(
        private actions$: Actions<LiveStreamAction>,
        private store: Store<AppState>,
        private stocksApiService: StocksApiService
    ) {}
}
